import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'accountingJobmonitor';

const jmWithAccountingJobMonitorService = {
  getProductionOperationsFromView: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionOperations/view`,
      data,
    });
  },

  joinOperation: (prodOperationId, userId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/joinOperation/${encodeURIComponent(prodOperationId)}/${encodeURIComponent(userId)}`,
    });
  },

  leaveOperation: (prodOperationId, userId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/leaveOperation/${encodeURIComponent(prodOperationId)}/${encodeURIComponent(userId)}`,
    });
  },

  closeAllOpenedProductionReport: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/closeAllOpenedProductionReport`,
      data,
    });
  },
};

export default jmWithAccountingJobMonitorService;
